var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49113 2.15498C5.18136 2.15498 3.92525 2.67528 2.99911 3.60142C2.07296 4.52756 1.55266 5.78368 1.55266 7.09344C1.55266 8.4032 2.07296 9.65932 2.99911 10.5855C3.92525 11.5116 5.18136 12.0319 6.49113 12.0319C7.80089 12.0319 9.057 11.5116 9.98315 10.5855C10.9093 9.65932 11.4296 8.4032 11.4296 7.09344C11.4296 5.78368 10.9093 4.52756 9.98315 3.60142C9.057 2.67528 7.80089 2.15498 6.49113 2.15498ZM0.205811 7.09344C0.205895 6.08839 0.446998 5.09802 0.908894 4.20539C1.37079 3.31277 2.04001 2.54393 2.86042 1.96336C3.68082 1.3828 4.62849 1.00744 5.62393 0.868768C6.61937 0.730099 7.63354 0.832167 8.58139 1.16641C9.52923 1.50065 10.3831 2.05732 11.0714 2.78972C11.7596 3.52212 12.2622 4.40889 12.537 5.37566C12.8118 6.34242 12.8507 7.36097 12.6505 8.34588C12.4503 9.3308 12.0169 10.2533 11.3865 11.0361L14.3747 14.0252C14.4409 14.0869 14.4939 14.1612 14.5307 14.2438C14.5676 14.3265 14.5873 14.4156 14.5889 14.5061C14.5905 14.5965 14.5739 14.6863 14.54 14.7701C14.5062 14.854 14.4557 14.9302 14.3918 14.9941C14.3279 15.0581 14.2517 15.1085 14.1678 15.1423C14.084 15.1762 13.9942 15.1928 13.9037 15.1913C13.8133 15.1897 13.7241 15.1699 13.6415 15.1331C13.5589 15.0963 13.4846 15.0432 13.4229 14.977L10.4338 11.9888C9.51036 12.7326 8.39534 13.2 7.21753 13.3371C6.03973 13.4741 4.84718 13.2752 3.77762 12.7633C2.70806 12.2513 1.80513 11.4473 1.1731 10.4441C0.541069 9.44078 0.20573 8.27919 0.205811 7.09344Z",
    fill: "url(#paint0_linear_198_7917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_7917",
    x1: 0.205811,
    y1: 0.808655,
    x2: 14.5885,
    y2: 15.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#E36D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A841"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/seeMore.dea2acc6c4d459276615781998839943.svg";
export { ForwardRef as ReactComponent };